<div class="pane-mini" *ngIf="!pane || !pane.loaded else contentBlock">
  <loading-line height="40px" width="100%"></loading-line>
</div>
<ng-template #contentBlock>
  <div class="library-block" [ngClass]="pane.format" *ngIf="content.length && pane">
    <app-content-drag-scroll
      [items]="content"
      [libraryTitle]="blockTitle"
      [pane]="pane"
      [isLibrary]="true">
    </app-content-drag-scroll>
  </div>
</ng-template>
